import { Pipeline } from 'utils/types';

const pipelines = ({ data, meta }: { data: Pipeline[]; meta: any }) => ({
  meta,
  data: data.sort((a, b) => a.sequence - b.sequence),
});

const pipeline = ({ data }: { data: Pipeline }) => ({
  data,
});

export default { pipelines, pipeline };
